import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ApiMananger } from 'actions/rtkquery';
import HeaderFirst from 'utils/HeaderFirst';
import DepensesTable from './DepensesTable'; // Assume you've created this component
import useDepensesData from './useDepensesData'; // Custom hook for fetching and enhancing data
import './client.css'; // Adjust the CSS import path as needed
import { ADD_DEPENSE } from 'routes/navigation/navigationPaths';
import HeaderButton from 'utils/headerButton';
import TablePaginators from 'components/Pagination/TablePaginator';
import { toast } from 'react-toastify';
import { FaFileImport } from 'react-icons/fa';
import ModalImportSorties from 'pagesDossierClientCabinet/SaisieManuelle/ModalImportSorties';
import { useDeleteDepenseMutation } from 'actions/depenses/mutations';
import ConfirmDeleteModal from 'components/ConfirmDeleteModal';
import TableLoader from 'components/Loader/TableLoader';
import { useDossierRole } from 'contexts/DossierRoleContext';

const DepensesPage = () => {
  const { clientID: depense_id } = useParams();
  const { canEdit } = useDossierRole();
  const dispatch = useDispatch();
  console.log(depense_id);
  const { updatedDonnees, handleUpdateDepense, refetch, isLoading } = useDepensesData(depense_id);
  const [deleteDepense, { isLoading: isDeleting }] = useDeleteDepenseMutation();
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pageSize, setPageSize] = useState(10); // Default page size
  const [paginationIndex, setPaginationIndex] = useState(0);
  const [serachTerm, setSearchedTerm] = useState('');
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [viewArchived, setViewArchived] = useState(false);

  // Define the action handler for TablePaginator
  const handleActionSelected = (action) => {
    if (action === 'archive') {
      setViewArchived(!viewArchived); // Toggle between viewing archived and active depenses
    } else {
      console.log(`Action selected: ${action}`);
      // Handle other actions as necessary
    }
  };

  const term = serachTerm ? serachTerm.trim().toLowerCase() : '';
  const filteredData = updatedDonnees
    .filter((depense) => (viewArchived ? depense.archived : !depense.archived))
    .filter((depense) => {
      if (!term) return true;
      const nomFournisseur = (
        depense.fournisseurs_details?.nom ||
        depense.fournisseur_nom ||
        (typeof depense.fournisseurs === 'string' ? depense.fournisseurs : '') ||
        ''
      ).toLowerCase();
      const intitule = (depense.intitule || '').toLowerCase();
      const ref = (depense.reference_facture || depense.numero_piece || '').toLowerCase();
      const montant = String(depense.prix || depense.montant_total || '');
      return (
        nomFournisseur.includes(term) ||
        intitule.includes(term) ||
        ref.includes(term) ||
        montant.includes(term)
      );
    });

  const currentPageData = filteredData.slice(
    paginationIndex * pageSize,
    (paginationIndex + 1) * pageSize
  );

  const onEyesClick = () => {
    // Assuming only one row can be selected at a time for viewing details
    if (selectedRows.length === 1) {
      const selectedRowId = selectedRows[0];
      navigate(`detailDepense/${selectedRowId}?edit=true`);
    } else {
      console.log('No row selected or multiple selections made');
      toast.warning(
        "Tu ne peux sélectionner qu'une sortie pour voir les détails ou modifier"
      );
    }
  };
  const onClickArchive = async () => {
    if (selectedRows.length === 0) {
      toast.warning('Veuillez sélectionner au moins une sortie à archiver.');
      return;
    }

    try {
      // Déterminer le statut basé sur la première sortie sélectionnée
      const firstDepense = updatedDonnees.find((d) => d.id === selectedRows[0]);
      if (!firstDepense) {
        toast.error('Sortie non trouvée.');
        return;
      }

      const newArchivedStatus = !firstDepense.archived;
      
      // Archiver/Désarchiver toutes les sorties sélectionnées
      const updatePromises = selectedRows.map((id) => {
        const depense = updatedDonnees.find((d) => d.id === id);
        if (depense) {
          return handleUpdateDepense(id, { archived: newArchivedStatus })
            .catch(error => {
              console.error(`Erreur mise à jour sortie ${id}:`, error);
              return { error, id };
            });
        }
        return Promise.resolve();
      });

      const results = await Promise.all(updatePromises);
      
      // Vérifier s'il y a eu des erreurs
      const errors = results.filter(r => r && r.error);
      const successes = selectedRows.length - errors.length;
      
      if (successes > 0) {
        toast.success(
          `${successes} sortie(s) ${newArchivedStatus ? 'archivée(s)' : 'désarchivée(s)'} avec succès.`
        );
      }
      
      if (errors.length > 0) {
        toast.error(`${errors.length} sortie(s) n'ont pas pu être mise(s) à jour.`);
      }
      
      setSelectedRows([]); // Réinitialiser la sélection
    } catch (error) {
      toast.error(
        'Une erreur est survenue lors de la mise à jour des sorties.'
      );
      console.error('Erreur lors de la mise à jour des sorties :', error);
    }
  };

  const onClickDelete = () => {
    if (selectedRows.length === 0) {
      toast.warning('Veuillez sélectionner au moins une sortie à supprimer.');
      return;
    }
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      // Supprimer toutes les dépenses sélectionnées
      const deletePromises = selectedRows.map((id) => 
        deleteDepense(id).unwrap().catch(error => {
          console.error(`Erreur suppression sortie ${id}:`, error);
          return { error, id };
        })
      );
      
      const results = await Promise.all(deletePromises);
      
      // Vérifier s'il y a eu des erreurs
      const errors = results.filter(r => r && r.error);
      const successes = selectedRows.length - errors.length;
      
      if (successes > 0) {
        toast.success(
          `${successes} sortie(s) supprimée(s) avec succès. ` +
          `Les calculs comptables ont été mis à jour.`
        );
      }
      
      if (errors.length > 0) {
        errors.forEach(({ error, id }) => {
          const errorMessage = error?.data?.detail || error?.data?.error || error?.data?.message || `Erreur lors de la suppression de la sortie ${id}`;
          toast.error(errorMessage);
        });
      }
      
      setSelectedRows([]); // Réinitialiser la sélection
      setShowDeleteModal(false);
      refetch(); // Recharger les données
      
      // Invalider MANUELLEMENT les caches des créances/dettes
      dispatch(ApiMananger.util.invalidateTags(['INVALIDATE_DETTES', 'INVALIDATE_CREANCES', 'INVALIDATE_DOSSIER']));
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
      const errorMessage = error?.data?.error || error?.data?.message || 'Erreur lors de la suppression des sorties';
      toast.error(errorMessage);
      setShowDeleteModal(false);
    }
  };

  // Handle changing the page
  const handlePageChange = (newIndex) => {
    setPaginationIndex(newIndex);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchedTerm(newSearchTerm);
  };

  const handleRowSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedRows((prev) => [...prev, row.id]);
    } else {
      setSelectedRows((prev) => prev.filter((id) => id !== row.id));
    }
  };

  const handleFormDepense = () => {
    navigate(ADD_DEPENSE);
  };

  const openImportModal = () => setIsImportModalOpen(true);
  const closeImportModal = () => setIsImportModalOpen(false);
  const handleImportSuccess = () => {
    closeImportModal();
    refetch();
  };

  const ajoutFou = {
    fontFamily: 'Montserrat',
    fontWeight: '600',
    fontSize: '13px',
  };

  const nom = (
    <div style={{ display: 'flex' }}>
      <h4 className="titre-dossier">{viewArchived ? 'Sorties archivées' : 'Sorties'}</h4>
      <span className="nbrDossier">{filteredData?.length}</span>
    </div>
  );
  return (
    <div
      className="depenses-page"
      style={{
        backgroundColor: 'white',
        minHeight: '500px',
        borderRadius: '20px',
        padding: '15px',
      }}
    >
      <div className="d-flex align-items-center flex-wrap pb-3">
        <HeaderFirst
          nom={nom}
          description={
            <div>Voici toutes vos sorties {viewArchived && 'archivées'}</div>
          }
        />
        <div style={{ display: canEdit ? 'flex' : 'none', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          <button
            type="button"
            className="btn btn-outline-primary"
            style={{
              borderRadius: '31px',
              border: '1px solid #009688',
              padding: '8px 16px',
              backgroundColor: '#009688',
              color: 'white',
              fontSize: '14px',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
            onClick={openImportModal}
          >
            <FaFileImport />
            <span>Importer des sorties</span>
          </button>
          <button
            type="button"
            className="btn btn-outline-dark"
            style={{
              borderRadius: '31px',
              border: '1px solid #AEAEAE',
              padding: '8px',
            }}
            onClick={handleFormDepense}
          >
            <span style={ajoutFou}>+ Ajouter une dépense</span>
          </button>
        </div>
      </div>
      <HeaderButton
        isButtonsEnabled={selectedRows.length > 0}
        placeholder={'Rechercher une dépense'}
        onSearchChange={handleSearchChange}
        onEyesClick={onEyesClick}
        onClickArchive={onClickArchive}
        onClickDelete={onClickDelete}
      />
      {isLoading && (!updatedDonnees || updatedDonnees.length === 0) ? (
        <div style={{ background: '#ffffff', borderRadius: '12px', padding: '30px', border: '1px solid #e2eced' }}>
          <TableLoader
            message="Chargement des dépenses (sorties)..."
            subMessage="Récupération des opérations et détails fournisseurs"
            minHeight="280px"
          />
        </div>
      ) : updatedDonnees ? (
        <DepensesTable
          data={currentPageData.filter((depense) =>
            depense.fournisseurs_details?.nom
              ?.toLowerCase()
              ?.includes(serachTerm.toLowerCase())
          )}
          selectedRows={selectedRows}
          onSelectRow={handleRowSelect}
        />
      ) : null}
      {!isLoading && (!currentPageData || currentPageData.length === 0) && (
        <div className="d-flex justify-content-center fs-5 mt-4 text-muted">
          <p>Aucune dépense à afficher.</p>
        </div>
      )}
      {currentPageData && (
        <TablePaginators
          paginationIndex={paginationIndex}
          setPaginationIndex={handlePageChange}
          dataLength={filteredData.length}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onActionSelected={handleActionSelected}
          isViewingArchived={viewArchived}
        />
      )}
      <ModalImportSorties
        isOpen={isImportModalOpen}
        onClose={closeImportModal}
        dossierId={depense_id}
        onSuccess={handleImportSuccess}
      />
      
      <ConfirmDeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        itemCount={selectedRows.length}
        itemType="sortie"
        isLoading={isDeleting}
      />
    </div>
  );
};

export default DepensesPage;
